import "core-js/modules/es.array.join";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.split";
import "regenerator-runtime/runtime";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { bankList, memberBigV, userAdd } from '../../../../api/apis';
export default {
  data: function data() {
    return {
      dialogVisible: false,
      bankList: [{
        key: 0,
        value: '否'
      }, {
        key: 1,
        value: '是'
      }],
      form: {
        number: '',
        bigV: 1
      },
      rules: {
        bigV: [{
          require: true,
          validator: this.$tempModel.rules.money.validator,
          trigger: 'blur'
        }]
      }
    };
  },
  mounted: function mounted() {},
  methods: {
    show: function show(number, finish) {
      this.dialogVisible = true;
      this.form.number = number.join(',');
      this.finish = finish;
    },
    clickSubmit: function clickSubmit() {
      var _this = this;

      this.$refs['form'].validate(function (valid) {
        if (valid) {
          memberBigV({
            number: _this.form.number.split(','),
            big_v: _this.form.bigV
          }).then(function _callee(res) {
            return regeneratorRuntime.async(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _this.$message({
                      message: '操作成功',
                      type: 'success'
                    });

                    _this.dialogVisible = false;

                    if (_this.finish) {
                      _this.finish();
                    }

                  case 3:
                  case "end":
                    return _context.stop();
                }
              }
            });
          });
        }
      });
    }
  }
};